import { onResize } from "./helpers/utils"
/*

  1) the expandable root element should have an id #voyage__expandable
  2) the expandable activator should have an id #voyage__expandable--button
  3) the content should be children of VoyageExpandableContent component

*/

const handleClick = (event) => {
  const expandable = event.target.closest(
    "#voyage__expandable, [data-id='voyage__expandable']"
  )

  const contentHeight = expandable.querySelector(
    "#voyage__expandable--content-wrapper, [data-id='voyage__expandable--content-wrapper']"
  ).clientHeight
  const content = expandable.querySelector(
    "#voyage__expandable--content, [data-id='voyage__expandable--content']"
  )
  const closedContentHeight = expandable.getAttribute("data-closed-height")

  if (!expandable.classList.contains("expanded")) {
    content.style.height = `${contentHeight + 40}px` // "+ 40" is considered a padding for the content
    expandable.classList.add("expanded")
  } else {
    content.style.height = closedContentHeight
    expandable.classList.remove("expanded")
  }
}

const resizeAccordions = (event) => {
  const expandables = document.querySelectorAll(".voyage__accordion.expanded")

  Array.from(expandables).forEach(function (element) {
    const contentHeight = element.querySelector(
      "#voyage__expandable--content-wrapper, [data-id='voyage__expandable--content-wrapper']"
    ).clientHeight
    const content = element.querySelector(
      "#voyage__expandable--content, [data-id='voyage__expandable--content']"
    )
    content.style.height = contentHeight + 40 + "px"
  })
}

export const addExpandableListeners = () => {
  const expandables = Array.prototype.slice.call(
    document.querySelectorAll(
      "#voyage__expandable, [data-id='voyage__expandable']"
    )
  )

  expandables.forEach((expandable) => {
    const closedContentHeight = expandable.querySelector(
      "#voyage__expandable--content, [data-id='voyage__expandable--content']"
    ).clientHeight

    expandable.setAttribute("data-closed-height", `${closedContentHeight}px`)
    expandable
      .querySelector(
        "#voyage__expandable--button, [data-id='voyage__expandable--button']"
      )
      .addEventListener("click", handleClick)
  })

  onResize(resizeAccordions)
}

export const removeExpandableListeners = () => {
  const expandables = Array.prototype.slice.call(
    document.querySelectorAll(
      "#voyage__expandable, [data-id='voyage__expandable']"
    )
  )

  expandables.forEach((expandable) => {
    expandable.removeEventListener("click", handleClick)
  })
}
